import type { TFunction } from 'i18next';
import type { GameConfig } from '@swiss-magic/shared-types';

// i18n audit (2026-08-25) — dictionary values that used to render raw English
// from shared-types (games.ts labels, FIDE/BMAB title names). The catalogs
// live in the `common` namespace (defaultNS; nsSeparator is disabled, so
// callers pass a `useTranslation('common')`-bound t). shared-types keeps the
// English strings as canonical fallbacks — the backend/TRF writers still use
// them directly, which is correct: wire formats are locale-independent.

/** Rating column/field label for a game ("Rating" / "Ranking" / "Wertung"). */
export function ratingFieldLabel(config: GameConfig, tc: TFunction): string {
  return tc('game_fields.rating', { defaultValue: config.playerFields.ratingLabel });
}

/** External-ID column/field label ("FIDE ID" for chess, "Player ID" else). */
export function externalIdFieldLabel(config: GameConfig, tc: TFunction): string {
  const key = config.id === 'chess' ? 'game_fields.fide_id' : 'game_fields.player_id';
  return tc(key, { defaultValue: config.playerFields.externalIdLabel });
}

/** Localized FIDE title name; fallback = the English label from shared-types. */
export function fideTitleLabel(
  code: string,
  englishLabel: string,
  tc: TFunction,
): string {
  return tc(`fide_titles.${code}`, { defaultValue: englishLabel });
}

/** Localized BMAB title name; fallback = the English label from shared-types. */
export function bmabTitleLabel(
  code: string,
  englishLabel: string,
  tc: TFunction,
): string {
  return tc(`bmab_titles.${code}`, { defaultValue: englishLabel });
}
